<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Add Other Loan Application</h3>
        <b-form role="form" class="mt-4" @submit.prevent="addProductApplication">
            <b-row>                
                <b-col cols="12">
                    <b-form-group label="Product">
                        <el-select v-model="form.prod_oth_type" placeholder="Select" allow-create filterable>
                            <el-option
                                v-for="(item, index) in PRODUCT_TYPES"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Product Details">
                        <b-form-input
                            v-model="form.prod_oth_detail"
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Product Value (RM)">
                        <CurrencyInput
                            v-model="form.prod_oth_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                

                <b-col cols="12">
                    <h3 class="mb-4">Arrangement Fee</h3>
                </b-col>
    
                <b-col cols="10">
                    <b-form-group label="Arrangement Fee Amount">
                        <b-form-input
                        v-model="form.prod_oth_agreement_rate"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Arrangement Fee SST">
                        <b-form-radio-group
                            v-model="form.prod_oth_agreement_rate_sst"
                            :options="SST_OPTIONS"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                        <b-form-group label="Total Arrangement Fee (RM)">
                        <b-form-input
                        v-model="form.prod_oth_agreement_fees"
                        type="text"
                        required
                        disabled
                        placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Payment Mode">
                        <el-select v-model="form.prod_oth_pay_mode" placeholder="Select" filterable>
                            <el-option
                                v-for="(item, index) in PAYMENT_MODES"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-button block variant="primary" class="mb-5" type="submit">Add</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import {PRODUCT_OTHER_LOAN} from '@/assets/js/options.js'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    props:{
        proposal: Object,
        show_other_loan_application: Boolean,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        CurrencyInput,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    watch:{
        'form':{
            handler(newVal){
                if(newVal){ 
                    let sst_fee = parseFloat(this.form.prod_oth_agreement_rate) * parseFloat(this.form.prod_oth_agreement_rate_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.prod_oth_agreement_rate) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.prod_oth_agreement_fees = 0
                    }else{
                        this.form.prod_oth_agreement_fees = arrangement_fee_amount
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        show: {
            get() {
                return this.show_other_loan_application;
            },
            set(newVal) {
                this.$emit('update:show_other_loan_application', newVal);
            },
        },
    },
    data() {
        return {
            form: {
                prod_oth_type: '',
                prod_oth_detail: '',
                prod_oth_value: 0,
                prod_oth_pay_mode:'',
                prod_oth_agreement_rate: 0,
                prod_oth_agreement_rate_sst: 0,
                prod_oth_agreement_fees: 0
            },
            PRODUCT_TYPES: PRODUCT_OTHER_LOAN.PRODUCT_TYPES,
            PAYMENT_MODES: PRODUCT_OTHER_LOAN.PAYMENT_MODES,
            SST_OPTIONS: SST_OPTIONS
        }
    },
    methods: {
        addProductApplication(){
            if(this.form.prod_oth_type == ''){
                this.errorFunction(null, 'Product is missing.')
                return
            }
            let data = {
                "pcom_psal_id": this.proposal.psal_id,
								"pcom_loan_statue": "OTHER - "+this.form.prod_oth_type,
                "pcom_product_detail":{
                    "pcp_product_type":"OTHER",
                    "pcp_project_json": {
                        "prod_oth_type": this.form.prod_oth_type,
                        "prod_oth_detail":this.form.prod_oth_detail,
                        "prod_oth_value":this.form.prod_oth_value,
                        "prod_oth_pay_mode":this.form.prod_oth_pay_mode,
                        "prod_oth_agreement_rate":this.form.prod_oth_agreement_rate,
                        "prod_oth_agreement_rate_sst":this.form.prod_oth_agreement_rate_sst,
                        "prod_oth_agreement_fees":this.form.prod_oth_agreement_fees,
                    }
                }
            }

            axios.post(services.initial_proposal +'ccris-item', data, {headers:getHeader()})
                .then(res=>{
                    this.notifySuccess('<b>Proposal:</b> - Successfully Added Product.')
                    this.resetForm()
                    initialProposalEventBus.$emit('refresh-proposal-detail')
                    this.$emit('update:show_other_loan_application', false)
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        resetForm(){
            this.form.prod_oth_type =  '',
            this.form.prod_oth_detail =  '',
            this.form.prod_oth_value =  0,
            this.form.prod_oth_pay_mode = '',
            this.form.prod_oth_agreement_rate =  0,
            this.form.prod_oth_agreement_rate_sst =  0,
            this.form.prod_oth_agreement_fees =  0
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
    }
}
</script>